<template>
  <div id="conferences">
    <div class="ipub-filter-div">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="[12,16]">
          <ipub-col :span="2">
            <ipub-select v-model="status"
                         @change="changeState"
                         placeholder="ALL">
              <ipub-select-option v-for="item in statusList"
                                  :key="'editorList'+item"
                                  :value="item">
                {{item}}
              </ipub-select-option>
            </ipub-select>
          </ipub-col>
          <ipub-col :span="10">
            <site-search-group v-model.trim="params.name"
                               placeholder="Search by title or location"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <template v-if="showAdv">
          <ipub-row :gutter="[12,16]">
            <ipub-col :span="6"
                      class="flex">
              <span class="line-h-40 ipub-p2 fw-bd nowrap">Start Date</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width: 100%"
                                      :placeholder="['From','To']"
                                      @change="(e)=>{handleDateChange(e, 'startTime')}"
                                      v-model="startDate" />
            </ipub-col>

            <ipub-col :span="6"
                      class="flex">
              <span class="line-h-40 ipub-p2 fw-bd nowrap">End Date</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width: 100%"
                                      :placeholder="['From','To']"
                                      @change="(e)=>{handleDateChange(e, 'endTime')}"
                                      v-model="endDate" />
            </ipub-col>
          </ipub-row>
        </template>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showAdv = !showAdv}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>
    <div>
      <div class="relative ipub-p1 mar-b-30">
        <div class="ipub-tab-list">
          <a :class="['ipub-p1','ipub-cursor-pointer','ipub-tab-list--tab',titleStatu===item.statu?'active':'']"
             v-for="(item,index) in titleTab"
             :key="item.title+index"
             @click="changeStatus(item)">{{item.title}}</a>
        </div>
        <div class="right-option">
          <ipub-button v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.CONFERENCES.ADD')"
                       type="primary"
                       @click="add">
            Add New Conference
          </ipub-button>
        </div>
      </div>
      <ipub-table :columns="columns"
                  fixed
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:index="{record}">
          <span>{{(record.sort || record.sort ===0) ? record.sort : '--' }}</span>
        </template>
        <template v-slot:time="{text}">
          {{ text?$moment(text).format('HH:mm  DD / MM / YYYY'): '- -' }}
        </template>
        <template v-slot:conferenceStatus="{text}">
          <ipub-label size="small"
                      cover
                      style="width:80px"
                      type="success"
                      v-if="text === 'IN_PROGRESS'">On-going</ipub-label>
          <ipub-label size="small"
                      type="danger"
                      cover
                      style="width:80px"
                      v-else-if="text === 'FINISHED'">Finished</ipub-label>
          <ipub-label size="small"
                      type="default"
                      cover
                      style="width:80px"
                      v-else-if="text==='NOT_STARTED'">Not Started</ipub-label>
        </template>
        <template v-slot:status="{text}">
          <ipub-label size="small"
                      cover
                      style="width:80px"
                      type="success"
                      v-if="text">Published</ipub-label>
          <ipub-label size="small"
                      type="danger"
                      cover
                      style="width:80px"
                      v-else>Draft</ipub-label>
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip class="border-right"
                        v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.CONFERENCES.EDIT')">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="edit(record)" />
          </ipub-tooltip>
          <template v-if="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.CONFERENCES.PUBLISH')">
            <ipub-tooltip v-if="record.released"
                          class="border-right">
              <div slot="title">Unpublish</div>
              <ipub-icon type="iconDisable"
                         @click="able(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-else
                          class="border-right">
              <div slot="title">Publish</div>
              <ipub-icon type="iconAble"
                         @click="able(record)" />
            </ipub-tooltip>
          </template>
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.CONFERENCES.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <add-conferences ref="conferences-form"
                     :isVisable="isVisable"
                     @confirm="confirm"
                     @cancel="cancel"></add-conferences>
  </div>
</template>
<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
